import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SdsTextField',
  props: {
  label: {
    type: String,
    default: '',
  },
  required: {
    type: Boolean,
    default: false,
  },
  requiredLabel: {
    type: String,
    default: 'O campo é obrigatório',
  },
},
  setup(__props) {

const props = __props;



const rules = computed(() => {
  return props.required ? [(v: string) => !!v || props.requiredLabel] : [];
});

return { __sfc: true,props, rules }
}

})